import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children?: ReactNode;
  errorComponent?: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  render() {
    const { hasError } = this.state;
    const { children, errorComponent } = this.props;
    if (hasError) {
      return errorComponent;
    }

    return children;
  }
}

export default ErrorBoundary;
